<div class="page">
  <span class="eyebrow">Besök oss</span>
  <h1>Hitta hit</h1>

  <div class="panel map-card">
    <iframe
      class="map-frame"
      title="Karta till Österbydäck & Allservice"
      src="https://maps.google.com/maps?q=%C3%B6sterbybruk%20firststop&t=&z=13&ie=UTF8&iwloc=&output=embed"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade">
    </iframe>
  </div>
</div>
